export enum DialogBoxButtonColor {
  Default = '',
  Alt = 'alt',
  Red = 'red',
  Yellow = 'yellow',
  Green = 'green',
  Blue = 'blue'
}

export interface DialogBoxOption {
  text: string;
  callback: (string?) => void;
  callbackIsDefault?: boolean; // for if user keys Enter while focused in input box
  color?: DialogBoxButtonColor;
  href?: {
    url: string;
    target?: '_self' | '_blank';
  };
  routerLink?: string;
}
